import {
  PAYMENT_SET_PAGINATION,
  PAYMENT_SET_FILTERS,
  PAYMENT_RESET_FILTERS,
  PAYMENT_SET_SORTING,
  EVENT_PAYMENT_FILTER_SUBMIT,
} from "./mutation";

export default {
  namespaced: true,
  state: {
    collection: [],
    item: {
      payment: {},
      tainted: false,
      id: null,
    },
    paginator: {
      page: 1,
      pageSize: parseInt(process.env.VUE_APP_LIST_DEFAULT_SIZE),
    },
    sorting: {},
  },
  mutations: {
    [PAYMENT_SET_PAGINATION](state, data) {
      state.paginator = { ...state.paginator, ...data };
    },
    [PAYMENT_SET_FILTERS](state, data) {
      state.filters = {
        ...state.filters,
        ...data,
      };
    },
    [PAYMENT_RESET_FILTERS](state) {
      state.filters = { page: 1 };
      state.paginator = {
        page: 1,
        pageSize: parseInt(process.env.VUE_APP_LIST_DEFAULT_SIZE),
      };
    },
    [PAYMENT_SET_SORTING](state, data) {
      state.sorting = { ...state.sorting, ...data };
    },
    [EVENT_PAYMENT_FILTER_SUBMIT]() {},
  },
  getters: {
    getAll: (state) => {
      return {
        ...state.paginator,
        ...state.filters,
        ...state.sorting,
      };
    },
  },
  actions: {
    async setPagination({ commit }, { ...params }) {
      commit(PAYMENT_SET_PAGINATION, params);
    },
    async setFilters({ commit }, { ...params }) {
      commit(PAYMENT_SET_FILTERS, params);
    },
    async resetFilters({ commit }) {
      commit(PAYMENT_RESET_FILTERS);
    },
    async setSorting({ commit }, { ...params }) {
      commit(PAYMENT_SET_SORTING, params);
    },
    async submitFilterForm({ commit }, { ...params }) {
      commit(EVENT_PAYMENT_FILTER_SUBMIT, params);
    },
  },
};
